/*
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2025-12-04 11:23:07 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-01-19 18:12:11 +0800
 * @FilePath     : /ai-agent-lumina/src/utils/server/http-enum.js
 * @Description  : 请求相关枚举
 */

// 状态码
const responseStatus = new Map([
  [100, '服务器返回此代码表示已收到请求的第一部分，正在等待其他部分。'],
  [101, '服务器已确认并真被切换。'],
  [200, '服务器已成功处理了请求'],
  [201, '请求成功并且服务器创建了新的资源'],
  [202, '服务器已接受请求，但尚未处理。'],
  [203, '服务器已成功处理了请求，但返回的信息可能来自另一来源。'],
  [204, '服务器成功处理了请求，但没有返回任何内容。'],
  [205, '服务器成功处理成功'],
  [206, '服务器成功处理了部分 GET 请求。'],
  [300, '多种选择'],
  [301, '请求的网页已永久移动到新位置'],
  [302, '服务器目前从不同位置的网页响应请求，但请求者应继续使用原有位置来响应以后的请求。'],
  [303, '查看其它位置'],
  [304, '未修改'],
  [305, '使用代理'],
  [307, '临时重定向'],
  [400, '错误请求'],
  [401, '您还没有权限呢'],
  [403, '服务器拒绝了您的请求'],
  [404, '哎呀 ~，页面走丢了'],
  [405, '禁用请求中指定的方法'],
  [406, '不接受请求内容'],
  [407, '需要代理授权'],
  [408, '请求超时'],
  [409, '服务器在请求时发生冲突'],
  [410, '请求资源已删除'],
  [411, '需要有效长度'],
  [412, '未满足前提条件'],
  [413, '请求实体过大'],
  [414, '请求的URL过长'],
  [415, '不支持的媒体类型'],
  [416, '请求范围不符合要求'],
  [417, '未满足期望值'],
  [500, '服务器异常，正在竭力维修'],
  [501, '服务器异常，尚未实施'],
  [502, '服务器异常，错误网关'],
  [503, '服务器不可用'],
  [504, '服务器异常，网关超时'],
  [505, 'http版本不受支持'],
])


/**
 * 响应码消息回馈
 * @author: 花裤衩<yongming.bai@outlook.com>
 * @param {Number} c: 状态码
 * @return {String|Number} 状态码对应消息或者状态码本身
 */
export const responseMsg = (c) => {
  let code = Number(c)
  if(responseStatus.has(code)) {
    return responseStatus.get(code)
  } else {
    return c
  }
}

/**
 * headers
 * @author: 花裤衩<yongming.bai@outlook.com>
 */
export const contentEnum = {
  // json
  JSON: 'application/json;charset=UTF-8',
  // form-data qs
  FORM_URLENCODED: 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data
  FORM_DATA: 'application/x-www-form-urlencoded'
  // 'multipart/form-data;charset=UTF-8'
}